<template>
  <div id="instantProductDetails" class="mx-2">
    <v-row class="mb-4 ma-0">
      <v-btn @click="goBackToCategory" depressed color="secondary">
        <v-icon class="secondary-font-color" left>keyboard_arrow_left</v-icon>
        <div class="secondary-font-color">{{ $translate('BACK') }}</div>
      </v-btn>
    </v-row>

    <ProductOrder
      :selectedProduct="selectedProduct"
      @book-rental-products="onBookRentalProducts"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import uiHelpers from '@/shared/ui_helpers';
import doRequest from '@/api/dssRequest';
import ProductOrder from '@/components/event/eventDetails/productOrderComponents/ProductOrder';

export default {
  name: 'EventInstantProductDetails',
  components: {
    ProductOrder,
  },
  mixins: [uiHelpers],
  data() {
    return {
      selectedProduct: {},
      scrollToSectionRef: this.scrollToSection,
    };
  },
  props: {
    scrollToSection: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    ...mapGetters({
      userId: 'auth/userName',
    }),
  },
  mounted() {
    this.initProduct();
  },
  updated() {
    if (this.scrollToSectionRef) {
      this.scrollToSectionRef = false;
      window.EventBus.fire('scrollToRightPosition', '#instantProductDetails');
    }
  },
  beforeDestroy() {
    this.$store.commit('event/setCurrentProductId', '');
  },
  methods: {
    goBackToCategory() {
      this.$router.back();
      // this.$store.commit('event/setCurrentWatchedProduct', {});

      // let eventId = this.selectedProduct.EventId;
      // let categoryId = this.selectedProduct.Categories[0].Id;

      // if (this.$route.params.event_id != null) {
      //   eventId = this.$route.params.event_id;
      // }

      // if (this.$route.params.category_id != null) {
      //   categoryId = this.$route.params.category_id;
      // }

      // this.goToPage('ProductCategory', {
      //   event_id: eventId,
      //   category_id: categoryId,
      // });
    },
    initProduct() {
      // check if the product details already exist (if routing is from the booking suggestion)
      const prodInStore = this.$store.getters.getSelectedProduct;
      if (prodInStore != null && Object.keys(prodInStore).length > 0) {
        // set the product in the right variable
        this.selectedProduct = this.$store.getters.getSelectedProduct;
        // clear the store variable
        this.$store.commit('setSelectedProduct', {});
      } else {
        // call the getProducts call if the product details are not there
        this.getProducts();
      }
    },
    getProducts() {
      const payload = {
        IncludeAllPartnersInPartnerGroup: true,
        MatchName: '',
        ProductIds: Object.keys(this.$store.getters['event/currentProductId'])
          .length
          ? [this.$store.getters['event/currentProductId']]
          : [],
      };

      const object = this.$store.getters['auth/userObjectId'];

      doRequest(
        (response) => {
          [this.selectedProduct] = response.data.Products;

          this.$store.commit('event/setCurrentProductId', '');

          if (
            this.selectedProduct != null &&
            this.selectedProduct.MetaData != null
          ) {
            window.EventBus.fire(
              'updateMetaData',
              this.selectedProduct.MetaData
            );
          }
        },
        () => {
          // if the product is deleted go directly to the homepage
          this.goToPage('Homepage');
        },
        'getProducts',
        object,
        payload,
        'GET'
      );
    },
    onBookRentalProducts(rentalProducts) {
      this.$emit('bookRentalButtonPressed', rentalProducts);
    },
  },
};
</script>
